import { render, staticRenderFns } from "./FaqComponent.vue?vue&type=template&id=64a90606&"
import script from "./FaqComponent.vue?vue&type=script&lang=js&"
export * from "./FaqComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports